module.exports = __webpack_public_path__ + "img/qrcode-student.defbd1fc.jpg";